import { inject } from "vue";
import type { InjectionKey } from "vue";

/**
 * A wrapper around Vue's inject functionality which throws an
 * error if the requested dependency is not provided.
 * @param key The key of the dependency to inject
 */
export function injectRequired<T> ( key: InjectionKey<T> | string ): T {
  const service = inject<T>( key );

  if ( !service ) {
    throw new Error( "Missing required service" );
  }

  return service;
}
